import { render } from "./Button.vue?vue&type=template&id=4a64e403&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=4a64e403&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a64e403"]])

export default __exports__